import { render } from "./DiscountAction.vue?vue&type=template&id=7b3f5b04&ts=true"
import script from "./DiscountAction.vue?vue&type=script&lang=ts"
export * from "./DiscountAction.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__